import { IShippingAddress } from './Address.types';
import { ICartItem } from './CartItem.types';

export enum OrderStatus {
  SUCCESSFUL = 'SUCCESSFUL',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  // Logyx core saves an order as SENDING before it calls the supplier's system,
  // and makes it UNKNOWN when the answer proves neither success nor failure: it
  // may already be at the supplier (docs/BP-1219-ordering.md).
  SENDING = 'SENDING',
  UNKNOWN = 'UNKNOWN',
}

// What an order's state rests on, as Logyx core sends it with every order
// (logix-core docs/ordering.md, "The order fields"). Missing from a core older
// than BP-1219.
export interface IOrderOutcome {
  outcome?: string | null;
  // The reason, as the supplier's system or an admin gave it. Shown to users.
  outcome_message?: string | null;
  safe_to_resend?: boolean | null;
  // Whether a resend would be accepted now: Retry is shown only when true.
  resend_allowed?: boolean;
  // Answered from an earlier request: nothing was sent to the supplier again.
  replayed?: boolean;
}

// The field types follow Logyx core's order schema (logix-core
// flask_app/api_v1/schemas/orders/order_schema.py): connector_id is an integer,
// null for a manual order; internal_number, the supplier's number, is a string.
export interface IOrder extends IOrderOutcome {
  company_buyer: ICompanyBuyer;
  company_seller: ICompanySupplier;
  confirmed_delivery_date: string;
  connector_id?: number | null;
  id: number;
  internal_number?: string | null;
  lines: ICartItem[];
  number: string;
  reference: string;
  requested_delivery_date: string;
  shipping_address: IShippingAddress;
  status: OrderStatus;
  total_gross_price: number;
  total_net_price: number;
}

export interface IOrderResponseDTO extends IOrderOutcome {
  id: number;
  number: string;
  internal_number?: string | null;
  company_seller: ICompanySupplier;
  company_buyer: ICompanyBuyer;
  status: string;
  confirmed_delivery_date: string;
  requested_delivery_date: string;
  reference: string;
  created_at: string;
  quo: string;
  // The connector it was sent through; null for a manual order. In the list since
  // logix-core 35ae5676 (BP-1219): it tells "Check with supplier" from a manual FAILED.
  connector_id?: number | null;
}
export interface IOrderDTO {
  number: string;
  internal_number?: string | null;
  name: string;
  status: string;
  delivery_date: string;
  reference: string;
  created_at: string;
  // connected_quotation: string;
  navigationID: string;
}

export interface ICompanyBuyer {
  coc_number: string;
  email: string;
  id: number;
  name: string;
  phone_number: string;
  vat_number: string;
  website: string;
}

export interface ICompanySupplier {
  coc_number: string;
  email: string;
  id: number;
  name: string;
  phone_number: string;
  vat_number: string;
  website: string;
}
